import { render, staticRenderFns } from "./OutboundTransferPaymentMethods.template.vue?vue&type=template&id=14b80c38&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b80c38",
  null
  
)

export default component.exports